// * Supported UI locales — keep in sync with public/locales/*.json and i18n.ts

export const APP_LOCALES = ["en", "tr", "ar"] as const;

export type AppLocale = (typeof APP_LOCALES)[number];

// * Normalize detector / browser codes (e.g. en-US, ar-SA) to our AppLocale
export function normalizeAppLocale(lng: string | undefined | null): AppLocale {
  if (!lng || typeof lng !== "string") return "en";
  const base = lng.split("-")[0]?.toLowerCase();
  if (base === "tr") return "tr";
  if (base === "ar") return "ar";
  return "en";
}

// * BCP-47 tags for Intl / Date formatting
export function appLocaleToBcp47(locale: AppLocale): string {
  switch (locale) {
    case "tr":
      return "tr-TR";
    case "ar":
      return "ar";
    default:
      return "en-US";
  }
}
